import { type FC, type ReactNode } from "react";

import styled from "@emotion/styled";
import { Button, type ButtonProps, Tooltip, type TooltipProps } from "@snapchat/snap-design-system";

const NO_PERMISSION = "You do not have permission to perform this action";
const HAS_MUSIC = "This Lens contains a licensed Sound and cannot be flighted to your Camera Kit integration";

/**
 * If a user doesn't have a roles based permission to perform an action we should show a message
 * related to this before other reasons. This priority may change in the future.
 * @param hasMusic
 * @param hasPermission
 * @returns string
 */
const getActionDisabledContent = (hasMusic: boolean, hasPermission: boolean) => {
    if (!hasPermission) {
        return NO_PERMISSION;
    }
    if (hasMusic) {
        return HAS_MUSIC;
    }
    return "";
};

export type ActionDisabledTooltipProps = Omit<Partial<TooltipProps>, "children"> & {
    children?: ReactNode;
    hasPermission?: boolean;
    hasMusic?: boolean;
    message?: ReactNode;
};

export const ActionDisabledTooltip: FC<ActionDisabledTooltipProps> = ({
    children,
    hasPermission = true,
    hasMusic = false,
    message,
    ...tooltipProps
}) => {
    if (hasPermission && !hasMusic) {
        return <>{children}</>;
    }

    // div wrapper fix: https://github.com/react-component/tooltip/issues/18#issuecomment-411476678
    return (
        <Tooltip {...tooltipProps} content={message ?? getActionDisabledContent(hasMusic, hasPermission)}>
            <div>{children}</div>
        </Tooltip>
    );
};

// https://github.com/react-component/tooltip/issues/18#issuecomment-411476678
export const DisabledButtonToolipFix = styled(Button)<ButtonProps>`
    ${({ isDisabled }) => (isDisabled ? `pointer-events: none;` : null)}
`;
